// This file is part of Indico.UN.
// Copyright (C) 2019 - 2025 United Nations. All rights reserved.

import {bindTranslateComponents} from 'indico/react/i18n';

export const {Translate, PluralTranslate} = bindTranslateComponents('un');
